module.exports = __webpack_public_path__ + "static/media/unit 1-3.038a3543.jpg";